<template>
  <div class="my-customer-page">
    <el-dialog
      title="客保到期提醒"
      :visible.sync="expireDialog.visible"
      width="1080px"
      custom-class="expire-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-table
        v-loading="expireDialog.loading"
        :data="expireDialog.list"
        border
        stripe
        max-height="420"
      >
        <el-table-column
          prop="budget_name"
          label="聚合名称"
          min-width="160"
        />

        <el-table-column
          prop="identify_code"
          label="识别名称"
          min-width="220"
          show-overflow-tooltip
        />

        <el-table-column
          prop="sale_type_text"
          label="预算类型"
          width="110"
        />

        <el-table-column
          prop="product_names"
          label="主类预算产品"
          min-width="180"
          show-overflow-tooltip
        />

        <el-table-column
          prop="agent_name"
          label="代理商"
          min-width="180"
          show-overflow-tooltip
        />

        <el-table-column
          prop="release_time"
          label="到期时间"
          width="180"
        />

        <el-table-column
          prop="remaining_text"
          label="剩余时间"
          width="100"
        />
      </el-table>

      <el-pagination
        :current-page="expireDialog.page"
        :page-sizes="[10, 20, 50]"
        :page-size="expireDialog.page_size"
        layout="total, sizes, prev, pager, next"
        :total="expireDialog.total"
        style="margin-top: 16px; text-align: right;"
        @size-change="handleExpireDialogSizeChange"
        @current-change="handleExpireDialogPageChange"
      />

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="expireDialog.visible = false"
        >
          我知道了
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="直投聚合客保审核结果"
      :visible.sync="reviewResultDialog.visible"
      width="1080px"
      custom-class="expire-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <div style="margin: 12px 0px; display: flex; justify-content: space-between;">
        <div>
          共 <span style="color: #409eff">{{ reviewResultDialog.counts.all }}</span> 条审核结果   
          <span style="color: #67c23a; margin-left: 24px;">已通过 {{ reviewResultDialog.counts.approved }} 条</span>  
          <span style="color: #f56c6c; margin-left: 24px;">已驳回 {{ reviewResultDialog.counts.rejected }} 条</span> 
        </div>
        <div style="color: #f56c6c">已驳回的聚合请在修改截止前，在【我的聚合】页重新提交，逾期将进入公海。</div>
      </div>
      
      <el-table
        v-loading="reviewResultDialog.loading"
        :data="reviewResultDialog.list"
        border
        stripe
        max-height="420"
      >
        <el-table-column
          prop="budget_name"
          label="聚合名称"
          min-width="160"
        />

        <el-table-column
          prop="identify_code"
          label="识别名称"
          min-width="220"
          show-overflow-tooltip
        />

        <el-table-column
          prop="audit"
          label="审核结果"
          width="110"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.audit === 2 ? 'danger' : scope.row.audit === 1 ? 'success' : 'info'">
              {{ scope.row.audit === 2 ? '已驳回' : scope.row.audit === 1 ? '已通过' : '--' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="audit_time"
          label="审核日期"
          min-width="180"
        />

        <el-table-column
          prop="end_time"
          label="客保期限"
          min-width="180"
        >
          <template slot-scope="scope">
            <div :style="{color: scope.row.end_date_color}">{{ scope.row.end_date_text || '--' }}</div>
            <div>{{ scope.row.end_time }}</div>
          </template>
        </el-table-column>
        
        <el-table-column
          prop="audit_reason"
          label="审核意见"
          width="180"
        />
      </el-table>

      <el-pagination
        :current-page="reviewResultDialog.page"
        :page-sizes="[10, 20, 50]"
        :page-size="reviewResultDialog.page_size"
        layout="total, sizes, prev, pager, next"
        :total="reviewResultDialog.total"
        style="margin-top: 16px; text-align: right;"
        @size-change="handleReviewResultDialogSizeChange"
        @current-change="handleReviewResultDialogPageChange"
      />

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="reviewResultDialog.visible = false"
        >
          我知道了
        </el-button>
      </div>
    </el-dialog>

    <div
      v-if="showExpireNotice"
      class="expire-notice"
    >
      <div class="expire-notice__icon">
        <i class="el-icon-warning-outline" />
      </div>

      <div class="expire-notice__viewport">
        <div
          class="expire-notice__track"
          :class="{ 'is-animating': expireNotice.animating }"
          :style="expireNoticeTrackStyle"
          @transitionend="handleExpireNoticeTransitionEnd"
        >
          <div class="expire-notice__item">
            {{ currentExpireNotice.text }}
          </div>
          <div
            v-if="hasMultipleExpireNotice"
            class="expire-notice__item"
          >
            {{ nextExpireNotice.text }}
          </div>
        </div>
      </div>
    </div>

    <div class="stats-section">
      <div class="stats-card">
        <div style="padding: 0px 24px; flex: 1;">
          <div class="stats-card__value">{{ statistics.currentProtectedCount }}</div>
          <div class="stats-card__label">当前客保数</div>
        </div>
        <img :src="blue">
      </div>
    </div>

    <div class="query-conditions">
      <el-form
        :inline="true"
        class="query-form"
        @submit.native.prevent
      >
        <el-row
          :gutter="20"
          class="query-row"
        >
          <el-col
            v-show="queryFieldVisibility.budget_name"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.budget_name"
                clearable
                placeholder="请输入聚合名称"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.identify_code"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.identify_code"
                clearable
                placeholder="请输入识别名称"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.product_name"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.product_name"
                clearable
                placeholder="请输入主类预算产品"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.sale_type"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-select
                v-model="query.form.sale_type"
                clearable
                style="width: 100%;"
                placeholder="请选择预算类型"
              >
                <el-option
                  v-for="item in saleTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.release_time_type"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-select
                v-model="query.form.release_time_type"
                clearable
                style="width: 100%;"
                placeholder="请选择释放时间"
              >
                <el-option
                  v-for="item in releaseTimeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.owner_name"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.owner_name"
                clearable
                placeholder="请输入所属"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            :span="queryActionSpan"
            class="query-item query-item--actions"
          >
            <div class="query-buttons">
              <el-button
                plain
                type="primary"
                :loading="table.loading"
                @click="handleReset"
              >
                重置
              </el-button>

              <el-button
                type="primary"
                :loading="table.loading"
                @click="handleFilter"
              >
                查询
              </el-button>

              <el-button
                v-if="showQueryToggle"
                type="text"
                class="query-toggle"
                @click="toggleQueryExpand"
              >
                {{ queryExpanded ? '收起' : '展开' }}
                <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div
      v-loading="table.loading"
      class="table-section"
    >
      <el-table
        :data="table.list"
        border
        stripe
        style="width: 100%;"
      >
        <el-table-column
          prop="budget_name"
          label="聚合名称"
          min-width="200"
        />

        <el-table-column
          prop="identify_names_text"
          label="识别名称"
          min-width="260"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.identify_names.length"
              class="tag-summary"
            >
              <el-tag
                type="success"
                class="tag-summary__first"
              >
                {{ scope.row.identify_names[0] }}
              </el-tag>

              <el-popover
                v-if="scope.row.identify_names.length > 1"
                placement="top"
                width="420"
                trigger="click"
              >
                <div class="tag-list-popover">
                  <el-tag
                    v-for="item in scope.row.identify_names"
                    :key="item"
                    type="success"
                  >
                    {{ item }}
                  </el-tag>
                </div>
                <el-button
                  slot="reference"
                  type="text"
                >
                  更多
                </el-button>
              </el-popover>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="product_names_text"
          label="主类预算产品"
          min-width="240"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.product_names.length"
              class="tag-summary"
            >
              <el-tag
                type="info"
                class="tag-summary__first"
              >
                {{ scope.row.product_names[0] }}
              </el-tag>

              <el-popover
                v-if="scope.row.product_names.length > 1"
                placement="top"
                width="420"
                trigger="click"
              >
                <div class="tag-list-popover">
                  <el-tag
                    v-for="item in scope.row.product_names"
                    :key="item"
                    type="info"
                  >
                    {{ item }}
                  </el-tag>
                </div>
                <el-button
                  slot="reference"
                  type="text"
                >
                  更多
                </el-button>
              </el-popover>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="sale_type_label"
          label="预算类型"
          width="120"
        />

        <el-table-column
          prop="release_time_text"
          label="释放时间"
          width="200"
        />

        <el-table-column
          prop="owner_name_text"
          label="所属"
          min-width="140"
        />

        <template slot="empty">
          <div class="empty-wrap">
            <el-empty
              description="暂无数据"
              :image-size="100"
            />
          </div>
        </template>
      </el-table>

      <el-pagination
        :current-page.sync="query.form.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="query.form.page_size"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        class="table-pagination"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import queryGridByContainer from '@/common/js/queryGridByContainer';
import blue from '@/assets/image/insurance/blue@2x.png';

const req = new Request();

const SALE_TYPE_OPTIONS = [
  { label: '直投', value: '1' },
  { label: '渠道', value: '2' },
];

const RELEASE_TIME_OPTIONS = [
  { label: '7天内将释放', value: 1 },
  { label: '3天内将释放', value: 2 },
];

function hasValue(value) {
  if (value === 0 || value === '0' || value === false) return true;
  if (value === undefined || value === null) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  return true;
}

function safeTrim(value) {
  if (typeof value === 'string') return value.trim();
  if (value === undefined || value === null) return '';
  return String(value).trim();
}

function splitTextList(value) {
  if (Array.isArray(value)) {
    return value.map(item => safeTrim(item)).filter(Boolean);
  }

  const text = safeTrim(value);
  if (!text) return [];

  return text
    .replace(/[，、；;]/g, ',')
    .split(',')
    .map(item => item.trim())
    .filter(Boolean);
}

function pickValue(source = {}, keys = []) {
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (
      Object.prototype.hasOwnProperty.call(source, key) &&
      hasValue(source[key])
    ) {
      return source[key];
    }
  }
  return '';
}

export default {
  name: 'AggregationManageMyCustomer',
  mixins: [queryGridByContainer],
  data() {
    return {
      blue,
      expireNotice: {
        list: [],
        currentIndex: 0,
        animating: false,
        timer: null,
      },
      expireDialog: {
        visible: false,
        list: [],
        page: 1,
        page_size: 10,
        total: 0,
        loading: false,
        requestId: 0,
      },
      reviewResultDialog: {
        visible: false,
        list: [],
        page: 1,
        page_size: 10,
        total: 0,
        loading: false,
        requestId: 0,
        counts: {"approved": 0, "rejected": 0, "all": 0},
      },
      statistics: {
        currentProtectedCount: 0,
      },
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      queryExpanded: false,
      query: {
        form: {
          page: 1,
          page_size: 10,
          budget_name: '',
          identify_code: '',
          product_name: '',
          sale_type: '',
          release_time_type: '',
          owner_name: '',
        },
      },
    };
  },
  computed: {
    saleTypeOptions() {
      return SALE_TYPE_OPTIONS;
    },

    releaseTimeOptions() {
      return RELEASE_TIME_OPTIONS;
    },

    queryColumnsPerRow() {
      return Math.max(24 / this.queryColSpan, 1);
    },

    collapsedQueryCount() {
      return Math.min(
        Math.max(this.queryColumnsPerRow - 1, 1),
        this.queryFieldKeys.length,
      );
    },

    visibleQueryFieldCount() {
      return this.queryExpanded
        ? this.queryFieldKeys.length
        : this.collapsedQueryCount;
    },

    queryActionSpan() {
      const remainder = this.visibleQueryFieldCount % this.queryColumnsPerRow;
      const remainingColumns = remainder === 0
        ? this.queryColumnsPerRow
        : this.queryColumnsPerRow - remainder;

      return remainingColumns * this.queryColSpan;
    },

    queryFieldKeys() {
      return [
        'budget_name',
        'identify_code',
        'product_name',
        'sale_type',
        'release_time_type',
        'owner_name',
      ];
    },

    queryFieldVisibility() {
      const visibility = {};

      this.queryFieldKeys.forEach((key, index) => {
        visibility[key] = index < this.visibleQueryFieldCount;
      });

      return visibility;
    },

    showQueryToggle() {
      return this.queryFieldKeys.length > this.collapsedQueryCount;
    },

    showExpireNotice() {
      return this.expireNotice.list.length > 0;
    },

    hasMultipleExpireNotice() {
      return this.expireNotice.list.length > 1;
    },

    currentExpireNotice() {
      return this.expireNotice.list[this.expireNotice.currentIndex] || { text: '' };
    },

    nextExpireNotice() {
      if (!this.hasMultipleExpireNotice) {
        return this.currentExpireNotice;
      }

      const nextIndex =
        (this.expireNotice.currentIndex + 1) % this.expireNotice.list.length;
      return this.expireNotice.list[nextIndex] || { text: '' };
    },

    expireNoticeTrackStyle() {
      return {
        transform: this.expireNotice.animating
          ? 'translateY(-44px)'
          : 'translateY(0)',
      };
    },
  },
  created() {
    this.getBudgetExpireNotice();
    this.getReviewResultNotice();
    this.getList();
  },
  beforeDestroy() {
    this.clearExpireNoticeTimer();
  },
  methods: {
    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },

    buildListParams() {
      const form = this.query.form;
      const params = {
        page: Number(form.page) || 1,
        page_size: Number(form.page_size) || 10,
        status: 1, //客保
      };

      if (hasValue(form.budget_name)) {
        params.budget_name = form.budget_name;
      }

      if (hasValue(form.identify_code)) {
        params.identify_code = form.identify_code;
      }

      if (hasValue(form.product_name)) {
        params.product_name = form.product_name;
      }

      if (hasValue(form.sale_type)) {
        params.sale_type = form.sale_type;
      }

      if (hasValue(form.release_time_type)) {
        params.release_time_type = form.release_time_type;
      }

      if (hasValue(form.owner_name)) {
        params.owner_name = form.owner_name;
      }

      // 基于当前仓库可用的聚合预算列表接口做客保页查询。
      // 若后端通过字段区分“我的客保”视图，这里同时兼容常见命名。
      params.is_customer = 1;
      params.is_protected = 1;

      return params;
    },

    normalizeRow(row = {}) {
      const identifyNames = splitTextList(
        pickValue(row, ['identify_code']),
      );
      const productNames = splitTextList(
        pickValue(row, ['product_names']),
      );
      const saleType = safeTrim(
        pickValue(row, ['sale_type']),
      );
      const releaseAt = pickValue(row, ['release_time']);
      const overDay = pickValue(row, ['release_time_type', 'release_day']);
      const ownerName = pickValue(row, ['owner_names']);

      return {
        ...row,
        budget_name: pickValue(row, ['budget_name', 'aggregation_name']) || '--',
        identify_names: identifyNames,
        identify_names_text: identifyNames.join('、') || '--',
        product_names: productNames,
        product_names_text: productNames.join('、') || '--',
        sale_type_label: this.getSaleTypeLabel(saleType),
        release_time_text: this.getReleaseTimeText(releaseAt, overDay),
        owner_name_text: ownerName || '--',
      };
    },

    normalizeExpireDialogRow(row = {}) {
      return {
        ...row,
        budget_name: pickValue(row, ['budget_name']) || '--',
        sale_type_text:
          pickValue(row, ['sale_type_text']) ||
          this.getSaleTypeLabel(pickValue(row, ['sale_type'])),
        identify_code: pickValue(row, ['identify_code']) || '--',
        product_names: pickValue(row, ['product_names']) || '--',
        agent_name: pickValue(row, ['agent_name']) || '--',
        release_time: pickValue(row, ['release_time']) || '--',
        remaining_text:
          pickValue(row, ['remaining_text']) ||
          (hasValue(row.remaining_days) ? `剩余${row.remaining_days}天` : '--'),
      };
    },

    normalizeResultDialogRow(row = {}) {
      let audit = pickValue(row, ['audit']) || '--';
      return {
        ...row,
        budget_name: pickValue(row, ['budget_name']) || '--',
        identify_code: pickValue(row, ['identify_code']) || '--',
        audit: pickValue(row, ['audit']) || '--',
        audit_date: pickValue(row, ['audit_date']) || '--',
        audit_time: pickValue(row, ['audit_time']) || '--',
        end_time: pickValue(row, ['end_time']) || '--',
        audit_reason:  pickValue(row, ['audit_reason']) || '--',
        end_date_text:  audit === 2 ? '修改截止' : audit === 1 ? '正式客保截止' : '--',
        end_date_color:  audit === 2 ? '#f56c6c' : audit === 1 ? '#666' : '#aaa'
      };
    },

    normalizeExpireNoticeRow(row = {}) {
      const budgetName = pickValue(row, ['budget_name']) || '--';
      const releaseTime = pickValue(row, ['release_time']) || '--';
      const remainingText =
        pickValue(row, ['remaining_text']) ||
        (hasValue(row.remaining_days) ? `剩余${row.remaining_days}天` : '');

      return {
        ...row,
        text: `【客保期提醒】聚合「${budgetName}」将于 ${releaseTime} 到期，${remainingText}，请及时跟进，到期后该聚合将进入公海客户池。`,
      };
    },

    getSaleTypeLabel(value) {
      const hit = this.saleTypeOptions.find(item => item.value === `${value}`);
      return hit ? hit.label : '--';
    },

    getReleaseTimeText(releaseAt, overDay) {
      if (hasValue(releaseAt)) {
        return safeTrim(releaseAt);
      }

      if (hasValue(overDay)) {
        const days = Number(overDay);
        if (!Number.isNaN(days)) {
          return `${days}天后释放`;
        }
      }

      return '--';
    },

    startExpireNoticeTimer() {
      this.clearExpireNoticeTimer();

      if (!this.hasMultipleExpireNotice) {
        return;
      }

      this.expireNotice.timer = setInterval(() => {
        if (this.expireNotice.animating) return;
        this.expireNotice.animating = true;
      }, 3000);
    },

    clearExpireNoticeTimer() {
      if (this.expireNotice.timer) {
        clearInterval(this.expireNotice.timer);
        this.expireNotice.timer = null;
      }
    },

    handleExpireNoticeTransitionEnd() {
      if (!this.expireNotice.animating || !this.hasMultipleExpireNotice) {
        return;
      }

      this.expireNotice.currentIndex =
        (this.expireNotice.currentIndex + 1) % this.expireNotice.list.length;
      this.expireNotice.animating = false;
    },

    async getBudgetExpireNotice() {
      try {
        this.expireDialog.page = 1;
        const res = await req.send(req.Apis.customer.aggregation.budgetExpire, {
          type: 1,
          page: this.expireDialog.page,
          page_size: this.expireDialog.page_size,
        });
        const data = res.data || {};
        const list = data.list || data.data || [];
        const sourceList = Array.isArray(list) ? list : [];
        const normalizedDialogList = sourceList
          .map(item => this.normalizeExpireDialogRow(item))
          .filter(item => hasValue(item.budget_name));
        const normalizedNoticeList = sourceList
          .map(item => this.normalizeExpireNoticeRow(item))
          .filter(item => hasValue(item.text));

        this.expireDialog.list = normalizedDialogList.slice(0, this.expireDialog.page_size);
        this.expireDialog.total = Number(data.total || normalizedDialogList.length);
        this.expireDialog.visible = normalizedDialogList.length > 0;
        this.expireNotice.list = normalizedNoticeList;
        this.expireNotice.currentIndex = 0;
        this.expireNotice.animating = false;
        this.startExpireNoticeTimer();
      } catch (err) {
        this.expireDialog.list = [];
        this.expireDialog.total = 0;
        this.expireDialog.visible = false;
        this.expireNotice.list = [];
        this.expireNotice.currentIndex = 0;
        this.expireNotice.animating = false;
        this.clearExpireNoticeTimer();
      }
    },

    async loadExpireDialogPage() {
      const requestId = ++this.expireDialog.requestId;
      this.expireDialog.loading = true;
      try {
        const res = await req.send(req.Apis.customer.aggregation.budgetExpire, {
          type: 1,
          page: this.expireDialog.page,
          page_size: this.expireDialog.page_size,
        });
        const data = res.data || {};
        if (requestId !== this.expireDialog.requestId) return;
        const list = data.list || data.data || [];
        this.expireDialog.list = (Array.isArray(list) ? list : [])
          .map(item => this.normalizeExpireDialogRow(item))
          .filter(item => hasValue(item.budget_name));
        this.expireDialog.total = Number(data.total != null ? data.total : this.expireDialog.total);
      } catch (err) {
        if (requestId === this.expireDialog.requestId) this.$message.error('获取客保到期提醒失败');
      } finally {
        if (requestId === this.expireDialog.requestId) this.expireDialog.loading = false;
      }
    },

    handleExpireDialogSizeChange(size) {
      this.expireDialog.page_size = size;
      this.expireDialog.page = 1;
      this.loadExpireDialogPage();
    },

    handleExpireDialogPageChange(page) {
      if (page === this.expireDialog.page) return;
      this.expireDialog.page = page;
      this.loadExpireDialogPage();
    },

    async getReviewResultNotice() {
      try {
        this.reviewResultDialog.page = 1;
        const res = await req.send(req.Apis.customer.aggregation.reviewResult, {
          page: 1,
          page_size: this.reviewResultDialog.page_size,
        });
        const data = res.data || {};
        const list = data.list || data.data || [];
        const sourceList = Array.isArray(list) ? list : [];
        const normalizedDialogList = sourceList
          .map(item => this.normalizeResultDialogRow(item))
          .filter(item => hasValue(item.budget_name));

        this.reviewResultDialog.list = normalizedDialogList;
        this.reviewResultDialog.total = Number(data.total || normalizedDialogList.length);
        this.reviewResultDialog.counts = data.counts || {"approved": 0, "rejected": 0, "all": 0}
        this.reviewResultDialog.visible = normalizedDialogList.length > 0;
        // this.startExpireNoticeTimer();
      } catch (err) {
        this.reviewResultDialog.list = [];
        this.reviewResultDialog.total = 0;
        this.reviewResultDialog.visible = false;
        this.reviewResultDialog.counts = {"approved": 0, "rejected": 0, "all": 0}
        this.reviewResultDialog.animating = false;
        // this.clearExpireNoticeTimer();
      }
    },

    async loadReviewResultDialogPage() {
      const requestId = ++this.reviewResultDialog.requestId;
      this.reviewResultDialog.loading = true;
      try {
        const res = await req.send(req.Apis.customer.aggregation.reviewResult, {
          page: this.reviewResultDialog.page,
          page_size: this.reviewResultDialog.page_size,
        });
        const data = res.data || {};
        if (requestId !== this.reviewResultDialog.requestId) return;
        const list = data.list || data.data || [];
        this.reviewResultDialog.list = (Array.isArray(list) ? list : [])
          .map(item => this.normalizeResultDialogRow(item))
          .filter(item => hasValue(item.budget_name));
        this.reviewResultDialog.total = Number(data.total != null ? data.total : this.reviewResultDialog.total);
        if (data.counts) this.reviewResultDialog.counts = data.counts;
      } catch (err) {
        if (requestId === this.reviewResultDialog.requestId) this.$message.error('获取审核结果失败');
      } finally {
        if (requestId === this.reviewResultDialog.requestId) this.reviewResultDialog.loading = false;
      }
    },

    handleReviewResultDialogSizeChange(size) {
      this.reviewResultDialog.page_size = size;
      this.reviewResultDialog.page = 1;
      this.loadReviewResultDialogPage();
    },

    handleReviewResultDialogPageChange(page) {
      if (page === this.reviewResultDialog.page) return;
      this.reviewResultDialog.page = page;
      this.loadReviewResultDialogPage();
    },

    async getList() {
      try {
        this.table.loading = true;
        const res = await req
          .send(req.Apis.customer.aggregation.groupList, this.buildListParams())
          .fin(() => {
            this.table.loading = false;
          });
        // const res = {
        //   code: 200,
        //   message: 'success',
        //   data: {
        //     total: 2,
        //     public_group_count: 23,
        //     claim_group_count: 23,
        //     my_protect_count: 8,
        //     list: [
        //       {
        //         id: 18,
        //         group_id: 10012,
        //         budget_id: 8891,
        //         status: 1,
        //         status_time: '2026-06-26 14:30:00',
        //         is_claim: 1,
        //         budget_name: '测试聚合A',
        //         identify_code: '北京某某科技有限公司',
        //         sale_type: 1,
        //         sale_type_text: '直投',
        //         open_account_status: 1,
        //         product_names: '穿山甲,巨量引擎',
        //         owner_names: '张三',
        //         release_time: '2026-08-25 14:30:00',
        //       },
        //       {
        //         id: 17,
        //         group_id: 10011,
        //         budget_id: 8890,
        //         status: 2,
        //         status_time: '2026-06-25 10:00:00',
        //         is_claim: 0,
        //         budget_name: '测试聚合B',
        //         identify_code: '上海某某信息技术有限公司',
        //         sale_type: 2,
        //         sale_type_text: '渠道',
        //         open_account_status: 0,
        //         product_names: '快手本地推',
        //         owner_names: '李四,王五',
        //         release_time: '2026-06-28 10:00:00',
        //       },
        //     ],
        //   },
        // };

        const data = res.data || {};
        const list = data.list || data.data || [];

        this.statistics.currentProtectedCount = Number(data.my_protect_count || 0);
        this.table.list = (Array.isArray(list) ? list : []).map(item =>
          this.normalizeRow(item),
        );
        this.table.total = Number(data.total || this.table.list.length || 0);
        this.table.loading = false;
      } catch (err) {
        this.table.loading = false;
        this.$message.error(`获取列表失败：${err.message || '未知错误'}`);
      }
    },

    handleFilter() {
      this.query.form.page = 1;
      this.getList();
    },

    handleReset() {
      this.query.form.budget_name = '';
      this.query.form.identify_code = '';
      this.query.form.product_name = '';
      this.query.form.sale_type = '';
      this.query.form.release_time_type = '';
      this.query.form.owner_name = '';
      this.query.form.page = 1;
      this.getList();
    },

    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize) || 10;
      this.query.form.page = 1;
      this.getList();
    },

    handleQueryPage(page) {
      this.query.form.page = Number(page) || 1;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.my-customer-page {
  min-width: 0;
}

.expire-notice {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 16px;
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(90deg, #fff4e8 0%, #fffaf5 100%);
  border: 1px solid #ffd3a8;
  box-shadow: 0 4px 12px rgba(230, 106, 0, 0.08);
}

.expire-notice__icon {
  flex: 0 0 auto;
  margin-right: 12px;
  color: #e67a00;
  font-size: 18px;
}

.expire-notice__viewport {
  flex: 1;
  height: 44px;
  overflow: hidden;
}

.expire-notice__track {
  will-change: transform;
}

.expire-notice__track.is-animating {
  transition: transform 0.45s ease;
}

.expire-notice__item {
  display: flex;
  align-items: center;
  height: 44px;
  color: #d14b00;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

/deep/ .expire-dialog .el-dialog__body {
  padding-top: 12px;
}

/deep/ .expire-dialog .el-dialog__header {
  border-bottom: 1px solid #f0f2f5;
}

.stats-section {
  margin-bottom: 24px;
}

.stats-card {
  width: 200px;
  width: 254px;
  align-items: center;
  height: 90px;
  display: flex;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(135deg, #f4f8ff 0%, #ffffff 100%);
  border: 1px solid #dbe7ff;
  box-shadow: 0 8px 20px rgba(31, 88, 173, 0.08);

  img{
    width: 71px;
  }
}

.stats-card__label {
  color: #6b778c;
  font-size: 14px;
  line-height: 22px;
}

.stats-card__value {
  margin: 8px 0 6px;
  color: #1f5fbd;
  font-size: 34px;
  line-height: 1;
  font-weight: 700;
}

.stats-card__desc {
  color: #9099ab;
  font-size: 13px;
  line-height: 20px;
}

.query-conditions {
  margin-bottom: 24px;
  padding: 20px 20px 8px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.query-form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 0;
}

.query-row {
  flex: 1 1 720px;
}

.query-item {
  margin-bottom: 12px;
}

.query-item--actions {
  display: flex;
  align-items: flex-start;
}

.query-buttons {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.query-toggle {
  padding: 0;
}

.table-section {
  padding: 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.table-pagination {
  margin-top: 24px;
  text-align: right;
}

.tag-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.tag-summary__first {
  max-width: calc(100% - 52px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tag-list-popover {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 240px;
  overflow-y: auto;
}

.empty-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
}

/deep/ .query-conditions .el-form-item {
  display: block;
  margin-right: 0;
  margin-bottom: 0;
}

/deep/ .query-conditions .el-form-item__content {
  display: block;
}

/deep/ .query-buttons .el-button + .el-button {
  margin-left: 0;
}

@media screen and (max-width: 767px) {
  .stats-card {
    min-height: 90px;
    // padding: 18px;
  }

  .stats-card__value {
    font-size: 28px;
  }

  .table-section,
  .query-conditions {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
